module.exports = __webpack_public_path__ + "fonts/5fa84fdd/proxima_nova_bold-punc.eot";